<template>
  <!-- 页面设置 -->
  <a-card>
    <a-tabs :default-active-key="0" tab-position="left" @change="handleChange">
      <a-tab-pane :key="index" :tab="item.tab" v-for="(item, index) in tabs">
        <base-info
          :baseInfo="item"
          :img="index == 0 ? logoUrl : item.img"
          @handleClickImg="handleClickImg"
        >
          <upload-icon
            ref="uploadIcon"
            @ok="_uploadLogo"
            :type="crtTab && crtTab.type"
            :suffixs="crtTab && crtTab.suffixs"
            :maxSize="1"
          >
            <div class="icon-preview-wrap ant-upload-preview">
              <a-icon type="cloud-upload-o" class="upload-icon" />
              <div class="mask">
                <a-icon type="plus" />
              </div>
              <img :src="item.img" />
            </div>
          </upload-icon>
        </base-info>
      </a-tab-pane>

      <a-tab-pane :key="2" tab="系统名称">
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item>
            <a-input
              :maxLength="15"
              placeholder="支持15个以内字符"
              v-decorator="[
                'name',
                {
                  rules: [{ required: true, message: '系统名称不能为空' }],
                  initialValue: sysName,
                },
              ]"
            />
          </a-form-item>
          <a-form-item>
            <a-button @click="handleReset" class="margin-right-20">
              重置
            </a-button>
            <a-button type="primary" html-type="submit">
              确认
            </a-button>
          </a-form-item>
        </a-form>
      </a-tab-pane>
    </a-tabs>
    <logo-modal
      v-if="tabIndex == 0"
      ref="modal"
      @ok="_uploadLogo"
      :type="crtTab && crtTab.type"
      :title="crtTab.modalTitle"
      :suffixs="crtTab && crtTab.suffixs"
      :maxSize="1"
    />
  </a-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { SET_LOGO_URL, SET_SYS_NAME } from 'config/mutation-types/app'
import BaseInfo from './components/BaseInfo'
import LogoModal from './components/LogoModal'
import UploadIcon from './components/UploadIcon'
import { queryByType, uploadLogo, setTitle } from './api'
import { ERR_OK } from 'config/index'
import { getEnvHost } from 'utils/util'
import { retrieveColumnLayout } from 'echarts/lib/layout/barGrid'

const host = getEnvHost()
const logoImgUrl = `${host}/logo`
const iconImgUrl = `${host}/icon`

export default {
  name: 'logo-setting',
  data() {
    const stamp = new Date().getTime()
    return {
      tabIndex: 0,
      tabs: [
        {
          tab: 'LOGO',
          type: 1,
          img: '',
          operator: '',
          updateTime: '',
          hintMsg: 'LOGO支持JPEG,JPG,PNG格式',
          suffixs: ['jpeg', 'jpg', 'png'],
          modalTitle: '修改LOGO',
        },
        {
          tab: '网页ico图标',
          type: 2,
          img: `${iconImgUrl}?_=${stamp}`,
          operator: '',
          updateTime: '',
          hintMsg: '支持ico格式，建议尺寸为 24px*24px', // TODO: 做upload的校验
          suffixs: ['ico'],
          modalTitle: '修改ico',
        },
      ],
      form: this.$form.createForm(this),
    }
  },
  computed: {
    ...mapGetters('app', ['logoUrl', 'sysName']),

    crtTab() {
      return this.tabs[this.tabIndex]
    },
  },
  mounted() {
    const crtTab = this.crtTab
    this._queryByType(crtTab.type)
  },
  methods: {
    ...mapMutations('app', [SET_LOGO_URL, SET_SYS_NAME]),
    async _queryByType(type) {
      try {
        const { data } = await queryByType(type)
        const tabIndex = this.tabIndex
        this.tabs[tabIndex].operator = data.operator
        this.tabs[tabIndex].updateTime = data.updateTime
      } catch (error) {
        console.error(error)
      }
    },
    handleChange(key) {
      this.tabIndex = key
      const crtTab = this.tabs[key]
      if (key == 1 && !crtTab.operator) {
        this._queryByType(crtTab.type)
        return
      }
    },
    handleClickImg() {
      this.$refs.modal.edit()
    },
    async _uploadLogo(formData) {
      try {
        await uploadLogo(formData)
        if (this.tabIndex == 0) {
          this.$refs.modal.closeLoading()
          this.$refs.modal.cancelHandel()
          this.$message.success('上传成功')
        } else if (this.tabIndex == 1) {
          this.$refs.uploadIcon[0].stopLoading()
          this.$message.success('上传成功，请刷新页面后查看')
        }
        this.setPic()
        this._queryByType(this.crtTab.type)
      } catch (error) {
        console.error(error)
      }
    },
    setPic() {
      const tabIndex = this.tabIndex
      const stamp = new Date().getTime()
      if (tabIndex == 0) {
        // logo
        const logoUrl = `${logoImgUrl}?_=${stamp}`
        this.tabs[this.tabIndex].img = logoUrl
        this.SET_LOGO_URL(logoUrl)
        retrieveColumnLayout
      }
      if (tabIndex == 1) {
        this.tabs[this.tabIndex].img = `${iconImgUrl}?_=${stamp}`
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (err) {
          return
        }
        try {
          const { code, message } = await setTitle(values)
          if (code == ERR_OK) {
            this.$message.success(message || '修改成功')
            this.SET_SYS_NAME(values.name)
          } else {
            this.$message.error(message || '失败')
          }
        } catch (error) {
          console.error(error)
        }
      })
    },
    handleReset() {
      this.form.resetFields()
    },
  },
  components: {
    BaseInfo,
    LogoModal,
    UploadIcon,
  },
}
</script>

<style lang="less" scoped>
.icon-preview-wrap {
  height: 180px;
  width: 180px !important;
}
.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
